import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoresService } from 'src/app/home/services/stores.service';
import { UserService } from 'src/app/home/services/user.service';

@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss', '../../app.component.scss', '../../shared/base-modal.style.scss']
})
export class EditUserComponent implements OnInit{
  public dialogData: any;

  public roles = [];
  public selectedRole = "";

  public stores = [];
  public selectedStores = [];
  public diplaySelectedStores = [];
  public isSelectAllStores = false;

  public isWebPermissions = "";
  public isHardwarePermissions = "";

  public contactNumberCode = "+353";

  public userDetails = {
    id: "",
    firstName: "",
    lastName: "",
    userName: "",
    roleId: "",
    email: "",
    contactNumber: "",
    emailNotificationEnabled:"",
    emailNotificationEnabledBool:false
  };

  public serverErrorMsg = "";

  constructor(
    public dialogRef: MatDialogRef<EditUserComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private storeService: StoresService
  ){
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getUser();
  }

  getUser(){
    this.userService.getUserDetails(this.dialogData.userId).subscribe((res)=>{
      if (res.data) {
        this.userDetails.id = res.data.user_id;
        this.userDetails.firstName = res.data.first_name;
        this.userDetails.lastName = res.data.last_name;
        this.userDetails.userName = res.data.username;
        this.userDetails.email = res.data.email;
        this.userDetails.emailNotificationEnabled = res.data.email_notification_enabled; 
        this.userDetails.emailNotificationEnabledBool = (res.data.email_notification_enabled == 'Y') ? true : false; 
        if (res.data.contact_number) {
          let contactNumber = res.data.contact_number.split(" ");
          this.contactNumberCode = contactNumber[0];
          this.userDetails.contactNumber = contactNumber[1];
        }

        this.onRoleChange({
          id: res.data.roles[0].id,
          name: res.data.roles[0].name
        });

        if (res.data.stores.length !== 0) {
          res.data.stores.forEach((store) => {
            this.selectedStores.push({
              id: store.id,
              name: store.name
            });
          });
        }

        this.getRoles();
      }
    })
  }
  
  getRoles(){
    this.userService.getRoles(['id', 'name']).subscribe((res)=>{
      this.roles = res.data;
    })
  }

  openRolesDropdown(event){
    let popupDiv = document.getElementById("roles-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation();

        document.addEventListener('click', function(event: any) {
          if (
            popupDiv.className.includes("active")
          ) {
            popupDiv.classList.remove("active");
          } 
        })
      }
  }

  openStoresDropdown(event){
    let popupDiv = document.getElementById("stores-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation();

        this.closePopupOutside("stores-dropdown");
      }
  }

  onRoleChange(role: any){
    this.userDetails.roleId = `${role.id}`;
    this.selectedRole = role.name;

    this.userService.getRoleDetails(role.id, 0).subscribe({
      next: (res) => {
        if (res.data) {
          this.isWebPermissions = res.data.is_web_permission;
          this.isHardwarePermissions = res.data.is_hardware_permission;

          if (this.isHardwarePermissions) {
            let loggedUser = JSON.parse(localStorage.getItem('role'));
            this.storeService.getStores(loggedUser.resource_id, ['id', 'name']).subscribe({
              next: (res) => {
                if (res.data.length !== 0) {
                  this.stores = res.data;
                }
              }
            })
          }
        }
      }
    });
  }

  onSelectAllStores(event){
    if (event.target.checked) {
      this.selectedStores = this.stores;
    }else{
      this.selectedStores = [];
    }
  }

  onSelectStores(event, store){
    if (event.target.checked) {
      this.selectedStores.push(store);  
    }else{
      this.selectedStores = this.selectedStores.filter((element)=>{
        return element.id !== store.id;
      });
    }

    this.isSelectAllStores = this.stores.length === this.selectedStores.length;

  }

  onRemoveSelectStore(storeId: number){
    this.selectedStores = this.selectedStores.filter((element)=>{
      return element.id !== storeId;
    });

    this.isSelectAllStores = this.stores.length === this.selectedStores.length;
  }

  isStoreSelected(storeId: number){
    return this.selectedStores.some((el) => el.id === storeId)
  }

  editUser(formData){
    if (formData.password === formData.password_confirmation) {
      if (this.isHardwarePermissions && this.selectedStores.length === 0) {
        return
      }

      if (this.isHardwarePermissions) {
        formData.stores = [];
        
        this.selectedStores.forEach((selectedStore) => {
          formData.stores.push(selectedStore.id)
        });
      }

      if(formData.email_notification_enabled == true)
        formData.email_notification_enabled ='Y';
      else
        formData.email_notification_enabled ='N';

      if (this.isWebPermissions) {
        let loggedUser = JSON.parse(localStorage.getItem('role'));
        formData.resource_id = [loggedUser.resource_id];
      }

      if (formData.contact_number !== "") {
        formData.contact_number = this.contactNumberCode + " " + formData.contact_number
      }

      formData.device = 'web';
      
      this.userService.editUser(this.userDetails.id, formData).subscribe({
        next: (res) => {
          if (res.data) {
            this.dialogRef.close(true);
          }
        },
        error: (errorResponse) => {
          if (errorResponse.error) {
            this.serverErrorMsg = errorResponse.error.message;
          }
          
        },
      });
    }
    
  }

  onClose(): void {
    this.dialogRef.close();
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
